// extracted by mini-css-extract-plugin
module.exports = {"UniverseSelectContainer":"UniverseSelect_UniverseSelectContainer__Ua4Tw"};